import { WebVitalsService } from './services/web-vitals.service';

/** Fire-and-forget: awaiting the dynamic import inside would block bootstrap. */
export function onAppInit(webVitalsService: WebVitalsService): void {
  void webVitalsService.register();
}
